import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M1 1C1 1 1.0099 1.00998 1.0199 1.03998"
        stroke={fill}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M2.50977 2.96997C5.10977 5.94997 11.1097 11.23 20.9797 11.23C33.2097 11.23 39.8798 4.59 42.0098 2"
        stroke={fill}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeDasharray="0.1 0.1"
      />
      <path
        d="M42.75 1.03998C42.77 1.01998 42.7699 1 42.7699 1"
        stroke={fill}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
